export const state = {
    list:[],
    structure:{},
    staff_list:[],
    mockdata: {}
};
